import {Injectable} from '@nestjs/common';
import { TransferAction } from '../transfer-action.entity';
import { TransferActionDTO } from './transfer-action.dto';

@Injectable()
export class TransferActionAdapter {
    /**
     * 
     * @param transferActionDTO 
     * @param isUpdate 
     * @returns 
     */

    public convertDtoToEntity( transferActionDTO: TransferActionDTO, isUpdate: boolean = false): TransferAction {
        const employee = new TransferAction();
        employee.transferActionId=transferActionDTO.transferActionId;
        employee.transferDate=transferActionDTO.transferDate;
        employee.employeeCode=transferActionDTO.employeeCode;
        employee.employeeName=transferActionDTO.employeeName;
        employee.designation=transferActionDTO.designation;
        employee.employeeRole=transferActionDTO.employeeRole;
        employee.approvedBy=transferActionDTO.approvedBy;
        employee.fromPlant=transferActionDTO.fromPlant;
        employee.toPlant=transferActionDTO.toPlant;
        employee.isActive=transferActionDTO.isActive==undefined?true:transferActionDTO.isActive;
        if (isUpdate){
            employee.updatedUser = transferActionDTO.updatedUser;
        }else {
            employee.isActive = true;
            employee.createdUser=transferActionDTO.createdUser;
        }
        return employee;
    }
    public convertEntityToDto( employeeData: TransferAction): TransferActionDTO{
        const transferActionDTO = new TransferActionDTO;
        transferActionDTO.transferActionId=employeeData.transferActionId;
        transferActionDTO.transferDate=employeeData.transferDate;
        transferActionDTO.employeeCode=employeeData.employeeCode;
        transferActionDTO.employeeName=employeeData.employeeName;
        transferActionDTO.designation=employeeData.designation;
        transferActionDTO.employeeRole=employeeData.employeeRole;
        transferActionDTO.approvedBy=employeeData.approvedBy;
        transferActionDTO.fromPlant=employeeData.fromPlant;
        transferActionDTO.toPlant=employeeData.toPlant;
        transferActionDTO.employeeRole=employeeData.employeeRole;
        transferActionDTO.isActive=employeeData.isActive;
        transferActionDTO.createdAt=employeeData.createdAt;
        transferActionDTO.createdUser=employeeData.createdUser;
        transferActionDTO.updatedAt=employeeData.updatedAt;
        transferActionDTO.updatedUser=employeeData.updatedUser;
        transferActionDTO.versionFlag=employeeData.versionFlag;
        return transferActionDTO;
    }
}